export const locales = ['en', 'fr', 'ar', 'ru', 'zh', 'ja', 'ko'] as const;
export const defaultLocale = 'en';
export type Locale = (typeof locales)[number];

export const localePrefix = 'always'; // or 'as-needed'